import moment from 'moment-timezone-all'

export const START_OF_REPORTS = moment('2017-12-01T00:00:00')

// OpenSearch-only accounts can't report further back than this.
export const OPENSEARCH_ONLY_MAX_LOOKBACK_DAYS = 30
